import { getEndOfPreviusMonth, getStartOfPreviusMonth } from '@app/libs/format'
import { Person, TableChart, FormatListBulleted, Add, CardGiftcard } from '@mui/icons-material'
import AddIcon from '@mui/icons-material/Add'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import { Translation } from 'react-i18next'

const start_at = getStartOfPreviusMonth()
const end_at = getEndOfPreviusMonth()

const voucher = {
  path: route('merchant.vouchers.index'),
  name: <Translation>{(t) => t('ADMIN_BREAD_CRUMBS_HEAD_TITLE.LIST_VOUCHERS')}</Translation>,
  icon: CardGiftcard,
  children: [
    {
      path: route('merchant.vouchers.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_VOUCHERS')}</Translation>,
      icon: FormatListBulleted,
    },
    {
      path: route('merchant.vouchers.request'),
      name: <Translation>{(t) => t('SLIDE_BAR.REQUESTED_VOUCHER')}</Translation>,
      icon: FormatListBulleted,
    },
    {
      path: route('merchant.vouchers.used', {
        used_at_start_at: start_at,
        used_at_end_at: end_at,
      }),
      name: <Translation>{(t) => t('SLIDE_BAR.EXPORT_USED_VOUCHERS')}</Translation>,
      icon: FormatListBulleted,
    },
    {
      path: route('merchant.vouchers.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_VOUCHER')}</Translation>,
      icon: Add,
    },
  ],
}

const pos = {
  name: <Translation>{(t) => t('ADMIN_BREAD_CRUMBS_HEAD_TITLE.LIST_POS')}</Translation>,
  icon: TableChart,
  children: [
    {
      path: route('merchant.pos.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_POS')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('merchant.pos.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_POS')}</Translation>,
      icon: AddIcon,
    },
  ],
}

const employee = {
  name: <Translation>{(t) => t('ADMIN_BREAD_CRUMBS_HEAD_TITLE.EMPLOYEES')}</Translation>,
  icon: Person,
  children: [
    {
      path: route('merchant.employees.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_EMPLOYEES')}</Translation>,
      icon: FormatListBulleted,
    },
    {
      path: route('merchant.employees.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_EMPLOYEE')}</Translation>,
      icon: Add,
    },
  ],
}

const routes = [voucher, pos, employee]

export default routes
